export default __webpack_public_path__ + "static/Shanly-main-2a6d326014d57bf399c622759470338f.png";